import { http } from "@di";
import actions from "./action";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./useCases";
const cRepositorires = repositories(http);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions);
export default {
    marginCalculator: cPresenters.marginCalculator,
};
